import { Autocomplete, TextField } from '@mui/material';

type Props = {
  driverEntities: { name: string, temporary: boolean, }[];
  value: string;
  id: number;
  updateDriverName: (id: number, value: string) => void;
  forceFocus: boolean;
  withLabel: boolean;
};

function DriverNameSelector({
  driverEntities,
  value,
  id,
  updateDriverName,
  forceFocus,
  withLabel,
}: Props) {
  return (
    <Autocomplete
      freeSolo
      fullWidth
      options={(driverEntities || []).filter((it) => !it.temporary).map((d) => d.name)}
      value={value || ''}
      onChange={(_, newValue) => {
        if (value !== newValue) {
          updateDriverName(id, newValue);
        }
      }}
      onBlur={(event) => {
        const newValue = (event.target as HTMLInputElement).value;
        if (value !== newValue) {
          updateDriverName(id, newValue);
        }
      }}
      openOnFocus
      renderInput={(inputParams) => (
        <TextField
          {...inputParams}
          margin="dense"
          type="text"
          label={withLabel ? 'ドライバー' : undefined}
          InputLabelProps={{ shrink: true }}
          variant="standard"
          fullWidth
          inputRef={(input: HTMLInputElement | null) => {
            if (!forceFocus) return;

            if (input) {
              input.focus();
            }
          }}
          sx={{ '& .MuiInputBase-root': { width: '100%' } }}
          onKeyDown={(event) => {
            const newValue = (event.target as HTMLInputElement).value;
            if (event.key === 'Tab' && value !== newValue) {
              updateDriverName(id, newValue);
            }
          }}
        />
      )}
      sx={{
        width: '100%', // Autocomplete の幅を横いっぱいに広げる
      }}
    />
  );
}
export default DriverNameSelector;
